const { axiosInstance } = require("helpers");

export const getDashboardSteps = async () => {
  return axiosInstance
    .get("dashboard/onboarding/steps", {
      params: {
        api_key: localStorage.getItem("apikey"),
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateDashboardSteps = async ({ name }) => {
  return axiosInstance
    .post("dashboard/onboarding/steps/update", {
        api_key: localStorage.getItem("apikey"),
        name,
        value: true,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
